<template>
  <div class="app-avatar" :title="name" :style="{width: size, height: size, fontSize: `calc(${size} / 2)`}">
    <div class="app-avatar__image-con" v-if="!showText && img">
      <img :src="img" :alt="shortName" @error="showText = true" class="app-avatar__image">
    </div>
    <div class="app-avatar__text-con" v-else>
      <div>
        {{ shortName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:     "AppAvatar",
  props:    {
    name: {
      required: true,
    },
    img:  {
      type: String,
    },
    size: {
      default: '50px',
      type:    String,
    },
  },
  data() {
    return {
      showText: false,
    };
  },
  computed: {
    shortName() {
      let name = this.name || "";
      let nameParts = name.split(' ');
      nameParts = nameParts.splice(0, 2).map(p => p[0]);
      let shortName = nameParts.join('');
      return shortName;
    },
  },
  watch:    {
    img() {
      this.showText = false;
    },
  },
};
</script>

<style lang="scss">
.app-avatar {
  flex-shrink: 0;

  &__image-con {
    width: 100%;
    height: 100%;
  }

  &__image {
    width: 100%;
    object-fit: cover;
    height: 100%;
    object-position: center;
    border-radius: 50%;
  }

  &__text-con {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 6px 1px rgba(69, 65, 78, .1);
    border-radius: 50%;
    background: rgba(var(--app-primary), 1);
    color: #fff;
    font-weight: 700;
    text-align: center;
    line-height: 1;
    user-select: none;
  }
}
</style>
